import { render } from "./ImagesModal.vue?vue&type=template&id=2b24c06b&scoped=true"
import script from "./ImagesModal.vue?vue&type=script&lang=js"
export * from "./ImagesModal.vue?vue&type=script&lang=js"

import "./ImagesModal.vue?vue&type=style&index=0&id=2b24c06b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b24c06b"]])

export default __exports__